import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Shop from "./pages/Shop";
import Configurator from "./pages/Configurator";
import BecomeSupplier from "./pages/BecomeSupplier";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SmartHomeAutomation from "./pages/SmartHomeAutomation";
import SecurityAndSurveillance from "./pages/SecurityAndSurveillance";
import IntercomSystem from "./pages/IntercomSystem";
import ScrollToTop from "./components/ScrollToTop";
import ContactPage from "./pages/ContactPage";
import SmartLockAccessControl from "./pages/SmartLockAndAccessControl";
import SoundSystems from "./pages/SoundSystems";
import LighteningSolutions from "./pages/LighteningSolutions";
import ElectricalAccessories from "./pages/ElectricalAccessories";
import DesignYourHome from "./pages/DesignYourHome";


export default function AppRouter() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/configurator" element={<Configurator />} />

          <Route path="/supplier" element={<BecomeSupplier />} />
          <Route path="/services/smart-home" element={<SmartHomeAutomation />} />
          <Route path="/services/security" element={<SecurityAndSurveillance />} />
          <Route path="/services/intercom" element={<IntercomSystem />} />
          <Route path="/services/smart-lock" element={<SmartLockAccessControl />} />
          <Route path="/services/sound" element={<SoundSystems />} />
          <Route path="/services/lightening" element={<LighteningSolutions />} />
          <Route path="/services/electrical" element={<ElectricalAccessories />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/design-home" element={<DesignYourHome />} />


        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}
